(() => {
  'use strict';

  const current = document.currentScript;
  if (!current?.src) return;

  const root = document.querySelector('[data-innungsprofil-verzeichnis]');
  if (!root) return;

  const base = current.src.split('?')[0].replace(/innungsprofil-history\.js$/, '');

  const normalize = (value) => String(value || '')
    .toLocaleLowerCase('de')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ß/g, 'ss')
    .replace(/&/g, ' und ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const handle = normalize(root.dataset.profileHandle || location.pathname.split('/').filter(Boolean).pop() || '');
  const title = normalize(root.dataset.profileTitle || '');
  const profileType = String(root.dataset.profileType || '').toUpperCase();
  const identity = `${handle} ${title}`;

  const has = (...tokens) => tokens.some((token) => identity.includes(normalize(token)));

  const load = (file) => new Promise((resolve, reject) => {
    const selector = `script[data-zb-history-selective="${file}"]`;
    const existing = document.querySelector(selector);
    if (existing) {
      if (existing.dataset.loaded === 'true') return resolve();
      existing.addEventListener('load', resolve, { once: true });
      existing.addEventListener('error', reject, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = base + file;
    script.async = false;
    script.dataset.zbHistorySelective = file;
    script.addEventListener('load', () => {
      script.dataset.loaded = 'true';
      resolve();
    }, { once: true });
    script.addEventListener('error', reject, { once: true });
    document.head.appendChild(script);
  });

  const loadSequence = async (files) => {
    for (const file of files) await load(file);
  };

  const waitForProfileReady = (timeoutMs = 5500) => new Promise((resolve) => {
    if (root.dataset.profileReady === 'true') return resolve(true);

    let settled = false;
    const finish = (ready) => {
      if (settled) return;
      settled = true;
      observer.disconnect();
      clearTimeout(timer);
      resolve(ready);
    };

    const observer = new MutationObserver(() => {
      if (root.dataset.profileReady === 'true') finish(true);
    });
    observer.observe(root, { attributes: true, attributeFilter: ['data-profile-ready'] });

    const timer = setTimeout(() => finish(root.dataset.profileReady === 'true'), timeoutMs);
  });

  const hwkBundle = () => {
    if (has('aachen')) return ['zunft-hwk-refinement-02-aachen.js'];
    if (has('suedwestfalen')) return ['zunft-hwk-refinement-02-suedwestfalen.js'];
    if (has('schwaben')) return [
      'zunft-hwk-refinement-02-schwaben.js',
      'zunft-hwk-refinement-02-corrections.js',
      'zunft-hwk-refinement-02-finalfix.js'
    ];
    if (has('ostfriesland', 'aurich')) return [
      'zunft-hwk-refinement-02-ostfriesland.js',
      'zunft-hwk-refinement-02-corrections.js'
    ];
    if (has('oberfranken')) return ['zunft-hwk-refinement-03-oberfranken.js'];
    if (has('berlin')) return ['zunft-hwk-refinement-03-berlin.js'];
    if (has('ostwestfalen-lippe', 'bielefeld')) return ['zunft-hwk-refinement-03-owl.js'];
    if (has('braunschweig-lueneburg-stade', 'braunschweig', 'lueneburg-stade')) return ['zunft-hwk-refinement-03-bls.js'];
    if (has('bremen')) return ['zunft-hwk-refinement-04-bremen.js'];
    if (has('cottbus')) return ['zunft-hwk-refinement-04-cottbus.js'];
    if (has('dortmund')) return ['zunft-hwk-refinement-04-dortmund.js'];
    if (has('duesseldorf')) return ['zunft-hwk-refinement-04-duesseldorf.js'];
    if (has('erfurt')) return ['zunft-hwk-refinement-05-erfurt.js'];
    if (has('flensburg')) return ['zunft-hwk-refinement-05-flensburg.js'];
    if (has('frankfurt-oder')) return ['zunft-hwk-refinement-05-frankfurt-oder.js'];
    if (has('frankfurt-rhein-main', 'frankfurt-am-main', 'rhein-main')) return ['zunft-hwk-refinement-05-frankfurt-rhein-main.js'];
    if (has('freiburg')) return ['zunft-hwk-refinement-06-freiburg.js'];
    if (has('ostthueringen', 'gera')) return ['zunft-hwk-refinement-06-ostthueringen.js'];
    if (has('halle')) return ['zunft-hwk-refinement-06-halle.js'];
    if (has('hamburg')) return ['zunft-hwk-refinement-06-hamburg.js', 'zunft-hwk-refinement-06-hamburg-fix.js'];
    if (has('hannover')) return ['zunft-hwk-refinement-07-hannover.js'];
    if (has('heilbronn-franken')) return ['zunft-hwk-refinement-07-heilbronn-franken.js'];
    if (has('hildesheim-suedniedersachsen', 'hildesheim', 'suedniedersachsen')) return ['zunft-hwk-refinement-07-hildesheim-suedniedersachsen.js'];
    if (has('pfalz')) return ['zunft-hwk-refinement-07-pfalz.js'];
    if (has('karlsruhe')) return ['zunft-hwk-refinement-08-karlsruhe.js'];
    if (has('kassel')) return ['zunft-hwk-refinement-08-kassel.js'];
    if (has('koblenz')) return ['zunft-hwk-refinement-08-koblenz.js'];
    if (has('koeln')) return ['zunft-hwk-refinement-08-koeln.js'];
    if (has('konstanz')) return ['zunft-hwk-refinement-09-konstanz.js'];
    if (has('luebeck')) return ['zunft-hwk-refinement-09-luebeck.js'];
    if (has('magdeburg')) return ['zunft-hwk-refinement-09-magdeburg.js'];
    if (has('mannheim')) return ['zunft-hwk-refinement-09-mannheim.js'];
    if (has('muenster')) return ['zunft-hwk-refinement-10-muenster.js'];
    if (has('saarland')) return ['zunft-hwk-refinement-10-saarland.js'];
    if (has('suedthueringen')) return ['zunft-hwk-refinement-10-suedthueringen.js'];
    if (has('ulm')) return ['zunft-hwk-refinement-10-ulm.js'];
    if (has('unterfranken')) return [
      'zunft-hwk-refinement-11-unterfranken-part-1.js',
      'zunft-hwk-refinement-11-unterfranken-part-2.js',
      'zunft-hwk-refinement-11-unterfranken-part-3.js',
      'zunft-hwk-refinement-11-unterfranken-part-4.js',
      'zunft-hwk-refinement-11-unterfranken.js'
    ];
    if (has('rheinhessen')) return [
      'zunft-hwk-refinement-11-rheinhessen-part-1.js',
      'zunft-hwk-refinement-11-rheinhessen-part-2.js',
      'zunft-hwk-refinement-11-rheinhessen-part-3.js',
      'zunft-hwk-refinement-11-rheinhessen-part-4.js',
      'zunft-hwk-refinement-11-rheinhessen.js'
    ];
    if (has('muenchen-oberbayern', 'muenchen', 'oberbayern')) return ['zunft-hwk-refinement-11-muenchen-oberbayern.js'];
    if (has('mittelfranken')) return ['zunft-hwk-refinement-11-mittelfranken.js'];
    if (has('oldenburg')) return [
      'zunft-hwk-refinement-12-oldenburg-part-1.js',
      'zunft-hwk-refinement-12-oldenburg-part-2.js',
      'zunft-hwk-refinement-12-oldenburg-part-3.js',
      'zunft-hwk-refinement-12-oldenburg-part-4.js',
      'zunft-hwk-refinement-12-oldenburg.js'
    ];
    if (has('osnabrueck')) return ['zunft-hwk-refinement-12-osnabrueck.js'];
    if (has('niederbayern-oberpfalz', 'niederbayern', 'oberpfalz')) return [
      'zunft-hwk-refinement-12-niederbayern-oberpfalz-core.js',
      'zunft-hwk-refinement-12-niederbayern-oberpfalz-chapters.js',
      'zunft-hwk-refinement-12-niederbayern-oberpfalz-timeline.js',
      'zunft-hwk-refinement-12-niederbayern-oberpfalz-sources.js'
    ];
    if (has('potsdam')) return [
      'zunft-hwk-refinement-12-potsdam-core.js',
      'zunft-hwk-refinement-12-potsdam-chapters.js',
      'zunft-hwk-refinement-12-potsdam-timeline.js',
      'zunft-hwk-refinement-12-potsdam-sources.js'
    ];
    if (has('reutlingen')) return [
      'zunft-hwk-refinement-13-reutlingen-core.js',
      'zunft-hwk-refinement-13-reutlingen-chapters.js',
      'zunft-hwk-refinement-13-reutlingen-timeline.js',
      'zunft-hwk-refinement-13-reutlingen-sources.js'
    ];
    if (has('ostmecklenburg-vorpommern', 'ostmecklenburg')) return [
      'zunft-hwk-refinement-13-ostmecklenburg-vorpommern-core.js',
      'zunft-hwk-refinement-13-ostmecklenburg-vorpommern-chapters.js',
      'zunft-hwk-refinement-13-ostmecklenburg-vorpommern-timeline.js',
      'zunft-hwk-refinement-13-ostmecklenburg-vorpommern-sources.js'
    ];
    if (has('schwerin')) return [
      'zunft-hwk-refinement-13-schwerin-core.js',
      'zunft-hwk-refinement-13-schwerin-chapters.js',
      'zunft-hwk-refinement-13-schwerin-timeline.js',
      'zunft-hwk-refinement-13-schwerin-sources.js'
    ];
    if (has('region-stuttgart', 'stuttgart')) return [
      'zunft-hwk-refinement-13-region-stuttgart-core.js',
      'zunft-hwk-refinement-13-region-stuttgart-chapters.js',
      'zunft-hwk-refinement-13-region-stuttgart-timeline.js',
      'zunft-hwk-refinement-13-region-stuttgart-sources.js'
    ];
    if (has('trier')) return [
      'zunft-hwk-refinement-14-trier-core.js',
      'zunft-hwk-refinement-14-trier-chapters.js',
      'zunft-hwk-refinement-14-trier-timeline.js',
      'zunft-hwk-refinement-14-trier-sources.js'
    ];
    if (has('wiesbaden')) return [
      'zunft-hwk-refinement-14-wiesbaden-core.js',
      'zunft-hwk-refinement-14-wiesbaden-chapters.js',
      'zunft-hwk-refinement-14-wiesbaden-timeline.js',
      'zunft-hwk-refinement-14-wiesbaden-sources.js'
    ];
    if (has('chemnitz')) return ['zunft-sachsen-refinement-01-hwk-chemnitz.js'];
    if (has('leipzig')) return ['zunft-sachsen-refinement-01-hwk-leipzig.js'];
    if (has('dresden')) return ['zunft-dresden-pilot-refinement.js'];
    return [];
  };

  const ihkBundle = () => {

    // Individuelle Chroniken: exakte Profilzuordnung, keine Änderung anderer Profile.
    const addedProfiles = {
      'industrie-und-handelskammer-ostwestfalen-zu-bielefeld': 'zunft-ihk-refinement-03-bielefeld.js',
      'industrie-und-handelskammer-mittleres-ruhrgebiet': 'zunft-ihk-refinement-03-bochum.js',
      'industrie-und-handelskammer-bonn-rhein-sieg': 'zunft-ihk-refinement-03-bonn.js',
      'industrie-und-handelskammer-braunschweig': 'zunft-ihk-refinement-03-braunschweig.js',
      'handelskammer-bremen-ihk-fur-bremen-und-bremerhaven': 'zunft-ihk-refinement-04-bremen.js',
      'industrie-und-handelskammer-zu-coburg': 'zunft-ihk-refinement-04-coburg.js',
      'industrie-und-handelskammer-darmstadt-rhein-main-neckar': 'zunft-ihk-refinement-04-darmstadt.js',
      'industrie-und-handelskammer-lahn-dill': 'zunft-ihk-refinement-04-lahn-dill.js',
      'industrie-und-handelskammer-lippe-zu-detmold': 'zunft-ihk-refinement-05-detmold.js',
      'industrie-und-handelskammer-zu-dortmund': 'zunft-ihk-refinement-05-dortmund.js',
      'industrie-und-handelskammer-zu-dusseldorf': 'zunft-ihk-refinement-05-duesseldorf.js',
      'niederrheinische-industrie-und-handelskammer-duisburg-wesel-kleve-zu-duisburg': 'zunft-ihk-refinement-05-niederrhein.js',
      'industrie-und-handelskammer-fur-ostfriesland-und-papenburg': 'zunft-ihk-refinement-05-emden.js',
      'industrie-und-handelskammer-fur-essen-mulheim-an-der-ruhr-oberhausen-zu-essen': 'zunft-ihk-refinement-05-essen.js',
      'industrie-und-handelskammer-zu-flensburg': 'zunft-ihk-refinement-05-flensburg.js',
      'industrie-und-handelskammer-fulda': 'zunft-ihk-refinement-05-fulda.js',
      'industrie-und-handelskammer-frankfurt-am-main': 'zunft-ihk-refinement-06-frankfurt.js',
      'industrie-und-handelskammer-gie-en-friedberg': 'zunft-ihk-refinement-06-giessen-friedberg.js',
      'industrie-und-handelskammer-limburg': 'zunft-ihk-refinement-06-limburg.js',
      'industrie-und-handelskammer-sudlicher-oberrhein': 'zunft-ihk-refinement-06-suedlicher-oberrhein.js',
      'industrie-und-handelskammer-hanau-gelnhausen-schluchtern': 'zunft-ihk-refinement-07-hanau.js',
      'industrie-und-handelskammer-kassel-marburg': 'zunft-ihk-refinement-07-kassel-marburg.js',
      'industrie-und-handelskammer-offenbach-am-main': 'zunft-ihk-refinement-07-offenbach.js',
      'industrie-und-handelskammer-wiesbaden': 'zunft-ihk-refinement-07-wiesbaden.js',
      'handelskammer-hamburg': 'zunft-ihk-refinement-08-hamburg.js',
      'industrie-und-handelskammer-hannover': 'zunft-ihk-refinement-08-hannover.js',
      'industrie-und-handelskammer-zu-kiel': 'zunft-ihk-refinement-08-kiel.js',
      'industrie-und-handelskammer-zu-lubeck': 'zunft-ihk-refinement-08-luebeck.js'
    };
    if (Object.prototype.hasOwnProperty.call(addedProfiles, handle)) return [addedProfiles[handle]];

    if (has('aachen')) return [
      'zunft-ihk-refinement-01-aachen-core.js',
      'zunft-ihk-refinement-01-aachen-chapters.js',
      'zunft-ihk-refinement-01-aachen-timeline.js',
      'zunft-ihk-refinement-01-aachen-sources.js'
    ];
    if (has('arnsberg')) return [
      'zunft-ihk-refinement-01-arnsberg-core.js',
      'zunft-ihk-refinement-01-arnsberg-chapters.js',
      'zunft-ihk-refinement-01-arnsberg-timeline.js',
      'zunft-ihk-refinement-01-arnsberg-sources.js'
    ];
    if (has('aschaffenburg')) return [
      'zunft-ihk-refinement-02-aschaffenburg-core.js',
      'zunft-ihk-refinement-02-aschaffenburg-chapters.js',
      'zunft-ihk-refinement-02-aschaffenburg-timeline.js',
      'zunft-ihk-refinement-02-aschaffenburg-sources.js'
    ];
    if (has('berlin')) return [
      'zunft-ihk-refinement-02-berlin-core.js',
      'zunft-ihk-refinement-02-berlin-chapters.js',
      'zunft-ihk-refinement-02-berlin-timeline.js',
      'zunft-ihk-refinement-02-berlin-sources.js'
    ];
    if (has('oberfranken-bayreuth', 'bayreuth')) return [
      'zunft-ihk-refinement-02-oberfranken-bayreuth-core.js',
      'zunft-ihk-refinement-02-oberfranken-bayreuth-chapters.js',
      'zunft-ihk-refinement-02-oberfranken-bayreuth-timeline.js',
      'zunft-ihk-refinement-02-oberfranken-bayreuth-sources.js'
    ];
    if (has('schwaben')) return [
      'zunft-ihk-refinement-02-schwaben-core.js',
      'zunft-ihk-refinement-02-schwaben-chapters.js',
      'zunft-ihk-refinement-02-schwaben-timeline.js',
      'zunft-ihk-refinement-02-schwaben-sources.js'
    ];
    if (has('chemnitz')) return ['zunft-sachsen-refinement-01-ihk-chemnitz.js'];
    if (has('leipzig')) return ['zunft-sachsen-refinement-01-ihk-leipzig.js'];
    if (has('dresden')) return ['zunft-dresden-pilot-refinement.js'];
    return [];
  };

  const federalBundle = () => {
    // Later D1/D2 records superseded earlier F-series entries in the legacy loader.
    // Load only the final, fully sourced record for these profiles.
    if (has('galvaniseure', 'graveure', 'metallbildner')) return ['zunft-history-rollout-d1.js'];
    if (has('gebaeudereiniger')) return ['zunft-history-rollout-d1.js'];
    if (has('glaserhandwerk')) return ['zunft-history-rollout-d1.js'];
    if (has('hoerakustiker')) return ['zunft-history-rollout-d2.js'];
    if (has('kaelteanlagenbauer')) return ['zunft-history-rollout-d2.js'];

    const groups = [
      { file: 'zunft-history-rollout-d4.js', tokens: ['zweirad-handwerk'] },
      { file: 'zunft-history-rollout-e1.js', tokens: ['augenoptiker', 'optometristen', 'baeckerhandwerk', 'baugewerbe'] },
      { file: 'zunft-history-rollout-e2.js', tokens: ['bestatter', 'buechsenmacher', 'buchbinder'] },
      { file: 'zunft-history-rollout-e3.js', tokens: ['dachdecker', 'druck-und-medien', 'elektro-und-informationstechnischen-handwerke', 'faltschachtel'] },
      { file: 'zunft-history-rollout-f1.js', tokens: ['farbe-gestaltung-bautenschutz', 'fleischer-verband', 'friseurhandwerk', 'galvaniseure', 'graveure', 'metallbildner'] },
      { file: 'zunft-history-rollout-f2.js', tokens: ['garten-landschaft', 'gebaeudereiniger', 'geruestbau', 'getreide', 'muehlen', 'staerkewirtschaft'] },
      { file: 'zunft-history-rollout-f3.js', tokens: ['glaserhandwerk', 'goldschmiede', 'silberschmiede'] },
      { file: 'zunft-history-rollout-f4.js', tokens: ['holz-und-bautenschutz'] },
      { file: 'zunft-history-rollout-f5.js', tokens: ['hoerakustiker', 'kaelteanlagenbauer'] },
      { file: 'zunft-history-rollout-f6.js', tokens: ['karosserie-und-fahrzeugtechnik', 'kuerschnerhandwerk'] },
      { file: 'zunft-history-rollout-f7.js', tokens: ['landbautechnik', 'maritime-wirtschaft'] },
      { file: 'zunft-history-rollout-f8.js', tokens: ['kraftfahrzeughandwerk', 'konditorenbund'] },
      { file: 'zunft-history-rollout-f9.js', tokens: ['orthopaedie-technik', 'orthopaedieschuhtechnik', 'rollladen', 'sonnenschutz'] },
      { file: 'zunft-history-rollout-f10.js', tokens: ['sanitaer-heizung-klima', 'zahntechniker', 'praezisionswerkzeugmechaniker'] },
      { file: 'zunft-history-rollout-f11.js', tokens: ['musikinstrumenten-handwerk', 'steinmetze', 'reifenhandel', 'vulkaniseur'] },
      { file: 'zunft-history-rollout-f12.js', tokens: ['kunsthandwerk', 'massschneiderhandwerk', 'bundesverband-metall', 'modell-und-formenbau'] },
      { file: 'zunft-history-rollout-f13.js', tokens: ['parkett', 'private-brauereien', 'raum-und-ausstattung', 'schilder-und-lichtreklame', 'schornsteinfeger'] },
      { file: 'zunft-history-rollout-f14.js', tokens: ['speiseeishersteller', 'uniteis', 'textilreinigung', 'tischler-schreiner-deutschland', 'uhren-schmuck', 'zeitmesstechnik'] }
    ];

    const group = groups.find((item) => item.tokens.some((token) => has(token)));
    return group ? [group.file] : [];
  };

  const specificBundle = () => {
    if (profileType === 'HWK') return hwkBundle();
    if (profileType === 'IHK') return ihkBundle();
    return federalBundle();
  };

  const renderFallback = async (reason) => {
    if (reason) console.warn('[Zunftbild] Selective history loader fallback.', reason);
    try {
      await load('innungsprofil-history-core.js');
    } catch (error) {
      console.error('[Zunftbild] History renderer could not be loaded.', error);
    }
  };

  (async () => {
    try {
      // Small shared baseline. It contains metadata/builders, not the full history library.
      await loadSequence([
        'zunft-history-rollout-a.js',
        'zunft-history-rollout-a2.js',
        'zunft-history-rollout-b.js',
        'zunft-history-rollout-b2.js'
      ]);

      await waitForProfileReady();

      // Build only the current profile's standard entry.
      await load('zunft-history-rollout-c.js');

      // Apply the common Dresden-quality structure to the current entry only.
      await load('zunft-dresden-standard-full-rollout.js');

      // Load only refinements that belong to the current profile.
      const bundle = specificBundle();
      if (bundle.length) await loadSequence(bundle);

      // Current-page corrections and then the renderer.
      await load('zunft-history-qa.js');
      await load('organisation-korrekturen-20260930.js?v=2');
      await load('innungsprofil-history-core.js');
    } catch (error) {
      await renderFallback(error);
    }
  })();
})();

